import React from 'react';
import { Layout } from 'antd';
import './index.less';
import { useAuth, useTranslateContext, useUserContext } from 'fennec-ui';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom'
import { useEffect } from 'react';
import RegisterJacTable from './RegisterJacTable';
import TotalPaymentTable from './TotalPaymentTable';
import EffektivnostSudeiEvent from './EffektivnostSudeiEvent';
import EffektivnostSudeiTour from './EffektivnostSudeiTour';
import EffektivnostSudeiDancer from './EffektivnostSudeiDancer';
import PredvzyatostSudiEvent from './PredvzyatostSudiEvent';
import PredvzyatostSudiZaPeriod from './PredvzyatostSudiZaPeriod';
import ReportKategoriiVoprosov from './ReportKategoriiVoprosov';
import ReportVoprosiSudeiskikhAttestatsii from './ReportVoprosiSudeiskikhAttestatsii';
import ReportTestiSudeiskikhAttestatsii from './ReportTestiSudeiskikhAttestatsii';
import ExtendedTotalPaymentTable from './ExtendedTotalPaymentTable';
import PaymentTableByOrders from './PaymentTableByOrders';
import OtchetSudeiskogoKomiteta from './OtchetSudeiskogoKomiteta';
import RegisterJacTableByDancerEvent from './RegisterJacTableByDancerEvent';

const { Header, Content } = Layout;

export default function Reports(props) {
    const auth = useAuth();
    const t = useTranslateContext();

    return (
        <div>
            <Routes>
                <Route path="register-jac-table/:eventid" element={<RegisterJacTable auth={auth} />} />
                <Route path="register-jac-table-by-dancer-event/:eventid" element={<RegisterJacTableByDancerEvent auth={auth} />} />
                <Route path="total-payment-table/:eventid/:usertype" element={<TotalPaymentTable auth={auth} />} />
                <Route path="extended-total-payment-table/:eventid/:usertype" element={<ExtendedTotalPaymentTable auth={auth} />} />
                <Route path="payment-table-by-orders/:eventid" element={<PaymentTableByOrders auth={auth} />} />
                <Route path="effektivnost-sudei/event/:eventid" element={<EffektivnostSudeiEvent auth={auth} />} />
                <Route path="effektivnost-sudei/tour/:tourid" element={<EffektivnostSudeiTour auth={auth} />} />
                <Route path="effektivnost-sudei/dancer/:dancertourid" element={<EffektivnostSudeiDancer auth={auth} />} />
                {/* <Route path="predvzyatost-sudi/event" element={<PredvzyatostSudiEvent auth={auth} />} /> */}
                <Route path="predvzyatost-sudi/period" element={<PredvzyatostSudiZaPeriod auth={auth} />} />
                <Route path="kategoriivoprosov/:id" element={<ReportKategoriiVoprosov auth={auth} />} />
                <Route path="voprosisudeiskikhattestatsii/:id" element={<ReportVoprosiSudeiskikhAttestatsii auth={auth} />} />
                <Route path="testisudeiskikhattestatsii/:id" element={<ReportTestiSudeiskikhAttestatsii auth={auth} />} />

                <Route path="otchetsudeiskogokomiteta/event/:eventid" element={<OtchetSudeiskogoKomiteta auth={auth} />} />


                <Route
                    path="*"
                    element={
                        <main style={{ padding: "1rem" }}>
                            <p>Тут ничего нет!</p>
                        </main>
                    }
                />
            </Routes>
        </div>
    );
};